export default __webpack_public_path__ + "static/media/capa-curso-beca-milano.757b2dff.jpg";